import {
  ChartRow,
  ChartRowElement,
  ChartRowGroup,
  ChartSubsection,
  ChartSubsectionContent,
  ChartSubsectionHeader,
} from "modules/charts-shared";
import { RADIOLOGY_GRID_COLUMNS } from "../radiology-chart/constants";
import { RadiologyInterpretationProps } from "../radiology-chart/types";
import { useFormContext } from "react-hook-form";

function F011Interpretation(props: RadiologyInterpretationProps) {
  const {
    index,
    chartCode,
    encounterId,
    sectionId,
    sectionCode,
    sectionSubCode,
    onRemoveElement,
  } = props;

  const { watch } = useFormContext();
  const sectionDelimiter = `rad.${index}.${chartCode}${sectionId}${sectionCode}${sectionSubCode}`;

  const isQ001A016Checked = Boolean(watch(`${sectionDelimiter}Q001A016`));
  const isQ001A017Checked = Boolean(watch(`${sectionDelimiter}Q001A017`));
  const isQ001A018Checked = Boolean(watch(`${sectionDelimiter}Q001A018`));
  const isQ001A019Checked = Boolean(watch(`${sectionDelimiter}Q001A019`));
  const isQ001A020Checked = Boolean(watch(`${sectionDelimiter}Q001A020`));

  return (
    <ChartSubsection
      header={
        <ChartSubsectionHeader
          showNotesBtn
          showDeleteBtn
          chartId={chartCode}
          encounterId={encounterId}
          sectionId={sectionCode}
          showInteractions={false}
          subsectionId={`${sectionSubCode}_Q001`}
          subsectionLabel="Metacarpal"
          showAuditsBtn={false}
          onDeleteSubSection={() => onRemoveElement(sectionId)}
        />
      }
      content={
        <ChartSubsectionContent>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement
                label="Metacarpal"
                name={`${sectionDelimiter}Q001A001`}
                type="cross-option"
              />
              <ChartRowElement
                label="L"
                name={`${sectionDelimiter}Q001A002`}
                type="cross-option"
              />
              <ChartRowElement
                label="R"
                name={`${sectionDelimiter}Q001A003`}
                type="cross-option"
              />
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="1st"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A004`}
                type="cross-option"
              />
              <ChartRowElement
                label="2nd"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A005`}
                type="cross-option"
              />
              <ChartRowElement
                label="3rd"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A006`}
                type="cross-option"
              />
              <ChartRowElement
                label="4th"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A007`}
                type="cross-option"
              />
              <ChartRowElement
                label="5th"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A008`}
                type="cross-option"
              />
              <ChartRowElement
                label="base"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A009`}
                type="cross-option"
              />
              <ChartRowElement
                label="shaft"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A010`}
                type="cross-option"
              />
              <ChartRowElement
                label="neck"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A011`}
                type="cross-option"
              />
              <ChartRowElement
                label="head"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A012`}
                type="cross-option"
              />
              <ChartRowElement
                label="Bennet’s"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A013`}
                type="cross-option"
              />
              <ChartRowElement
                label="Rolondo’s"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A014`}
                type="cross-option"
              />
              <ChartRowElement
                label="SH:"
                name={`${sectionDelimiter}Q001A015`}
                type="cross-option"
              />
              <ChartRowElement
                label="1"
                name={`${sectionDelimiter}Q001A016`}
                type="cross-option"
                isDisabled={
                  isQ001A017Checked ||
                  isQ001A018Checked ||
                  isQ001A019Checked ||
                  isQ001A020Checked
                }
              />
              <ChartRowElement
                label="2"
                name={`${sectionDelimiter}Q001A017`}
                type="cross-option"
                isDisabled={
                  isQ001A016Checked ||
                  isQ001A018Checked ||
                  isQ001A019Checked ||
                  isQ001A020Checked
                }
              />
              <ChartRowElement
                label="3"
                name={`${sectionDelimiter}Q001A018`}
                type="cross-option"
                isDisabled={
                  isQ001A016Checked ||
                  isQ001A017Checked ||
                  isQ001A019Checked ||
                  isQ001A020Checked
                }
              />
              <ChartRowElement
                label="4"
                name={`${sectionDelimiter}Q001A019`}
                type="cross-option"
                isDisabled={
                  isQ001A016Checked ||
                  isQ001A017Checked ||
                  isQ001A018Checked ||
                  isQ001A020Checked
                }
              />
              <ChartRowElement
                label="5"
                name={`${sectionDelimiter}Q001A020`}
                type="cross-option"
                isDisabled={
                  isQ001A016Checked ||
                  isQ001A017Checked ||
                  isQ001A018Checked ||
                  isQ001A019Checked
                }
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A021`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="nondisplaced"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A022`}
                type="cross-option"
              />
              <ChartRowElement
                label="displaced"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A023`}
                type="cross-option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A024`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
        </ChartSubsectionContent>
      }
    />
  );
}

export { F011Interpretation };
